// extracted by mini-css-extract-plugin
export var errorsContainer = "_u0-1";
export var link = "_u0-0";